module.exports = "/static/Images/images/VeryUnsatisfied.png";